/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_DescriptionInputs */

const en_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to open your schedule, your clients and their plans.`)
};

const pl_auth_login_description = /** @type {(inputs: Auth_Login_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się, żeby otworzyć swój grafik, podopiecznych i plany.`)
};

/**
* | output |
* | --- |
* | "Sign in to open your schedule, your clients and their plans." |
*
* @param {Auth_Login_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_description = /** @type {((inputs?: Auth_Login_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_description(inputs)
	return en_auth_login_description(inputs)
});